var _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0625 11.1875H21.7633L14.5379 3.96209C14.1718 3.59595 13.5782 3.59595 13.2121 3.96209C12.846 4.32823 12.846 4.92181 13.2121 5.2879L19.1117 11.1875H4.88831L10.7879 5.2879C11.154 4.92176 11.154 4.32818 10.7879 3.96209C10.4218 3.596 9.82819 3.59595 9.46209 3.96209L2.23669 11.1875H0.9375C0.419719 11.1875 0 11.6072 0 12.125C0 12.6428 0.419719 13.0625 0.9375 13.0625H1.8308L3.31411 21.9624C3.54108 23.3241 4.70784 24.3125 6.08836 24.3125H17.9116C19.2921 24.3125 20.4589 23.3241 20.6858 21.9624L22.1692 13.0625H23.0625C23.5803 13.0625 24 12.6428 24 12.125C24 11.6072 23.5803 11.1875 23.0625 11.1875ZM18.8364 21.6541C18.7607 22.1081 18.3718 22.4375 17.9116 22.4375H6.08836C5.62819 22.4375 5.23927 22.108 5.16361 21.6541L3.73167 13.0625H20.2683L18.8364 21.6541Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 20.5625C8.76778 20.5625 9.1875 20.1428 9.1875 19.625V15.875C9.1875 15.3572 8.76778 14.9375 8.25 14.9375C7.73222 14.9375 7.3125 15.3572 7.3125 15.875V19.625C7.3125 20.1428 7.73222 20.5625 8.25 20.5625Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.5625C12.5178 20.5625 12.9375 20.1428 12.9375 19.625V15.875C12.9375 15.3572 12.5178 14.9375 12 14.9375C11.4822 14.9375 11.0625 15.3572 11.0625 15.875V19.625C11.0625 20.1428 11.4822 20.5625 12 20.5625Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 20.5625C16.2678 20.5625 16.6875 20.1428 16.6875 19.625V15.875C16.6875 15.3572 16.2678 14.9375 15.75 14.9375C15.2322 14.9375 14.8125 15.3572 14.8125 15.875V19.625C14.8125 20.1428 15.2322 20.5625 15.75 20.5625Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 5,
    r: 5,
    fill: "#FFCB01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartDot);
export default __webpack_public_path__ + "static/media/cart-dot.5e2327e78ebcd54cda7db505f3f5301a.svg";
export { ForwardRef as ReactComponent };